export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': '主页',
  'menu.dashboard.Dashboard': '主页',
  'menu.dashboard.transactions': '交易',
  'menu.dashboard.wallets': '钱包',
  'menu.dashboard.hot-wallets': '热钱包',
  'menu.dashboard.fee-hot-wallets': '手续费热钱包',
  'menu.dashboard.consolidate-fund-logs': '资金归集记录',
  'menu.dashboard.consolidate-fee-logs': '手续费归集记录',
  'menu.dashboard.withdraw-logs': '提现记录',
  'menu.dashboard.withdraw-requests': '提现请求',
  'menu.dashboard.withdraw-fee-logs': '手续费提现记录',
  'menu.dashboard.sub-users': '子账号',
  'menu.dashboard.add-sub-user': '添加子账号',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.profile': '详情页',
  'menu.profile.userProfile': '用户设定',
  'menu.profile.settings': '用户设置',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
